import BaseService from '@/services/BaseService'
import {http} from './config'

class FuncionarioService extends BaseService {
    constructor(){
        super('/v1/funcionarios')
    }

    atualizarSenha(data){
        return http.post('/v1/funcionario-atualizar-senha', data)
    }

    adicionarDependente(data) {
        return http.post('/v1/funcionario/dependentes', data)
    }

    listarDependentes(data) { // data é o id do funcionário
        return http.get(`/v1/funcionario/dependentes?funcionario_id=${data}`)
    }

    excluirDependente(data) { // data é o id do dependente
        return http.delete(`/v1/funcionario/dependentes/${data}`)
    }

    visualizarDependente(data) { // data é o id do dependente
        return http.get(`/v1/funcionario/dependente/${data}`)
    }
    
    cadastrarDependente(data) {
        return http.post('/v1/funcionario/dependentes', data)
    }

    listarDependentes(data) { // data é o id do funcionário
        return http.get(`/v1/funcionario/dependentes?funcionario_id=${data}`)
    }
    
    excluirDependente(data) { // data é o id do dependente
        return http.delete(`/v1/funcionario/dependentes/${data}`)
    }
    
    visualizarDependente(data) { // data é o id do dependente
        return http.get(`/v1/funcionario/dependente/${data}`)
    }
    
    cadastrarSalario(data) {
        return http.post(`/v1/funcionario/salarios`, data)
    }
    
    listarSalarios(data) { // data é o id do funcionário
        return http.get(`/v1/funcionario/salarios?funcionario_id=${data}`)
    }
}

export default new FuncionarioService